import gql from "graphql-tag";
import PropTypes from "prop-types";
import sortby from "lodash.sortby";

export default {
  query: gql`
    query merchantsList(
      $companyId: String
      $merchantIds: String
      $merchantName: String
      $rowFrom: Int
      $rowTo: Int
    ) {
      merchants(
        companyId: $companyId
        merchantIds: $merchantIds
        merchantName: $merchantName
        rowFrom: $rowFrom
        rowTo: $rowTo
      ) {
        id: merchantId
        merchantName
        address
        city
        zipCode
        companyId
        companyName
        currentRow
        totalRows
      }
    }
  `,
  variables: ({
    companyId,
    merchantIds,
    merchantName,
    page = 1,
    itemsPerPage = 10,
  }) => {
    const firstItem = (page - 1) * itemsPerPage || 1;
    const lastItem = firstItem + itemsPerPage;
    return {
      companyId,
      merchantIds:
        merchantIds && merchantIds.join ? merchantIds.join(",") : merchantIds,
      merchantName,
      rowFrom: firstItem,
      rowTo: lastItem,
    };
  },
  config: {
    pollInterval: 0,
    errorPolicy: "none",
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  },
  propTypes: {
    companyId: PropTypes.string,
    merchantIds: PropTypes.string,
    merchantName: PropTypes.string,
    page: PropTypes.number,
    itemsPerPage: PropTypes.number,
  },
  dataKey: "merchants",
  sort: (items) => sortby(items, (o) => parseInt(o.id, 10)),
  getTotal: (items) => (items && items.length ? items[0].totalRows : null),
};



// WEBPACK FOOTER //
// ./src/model/gql/queries/merchants.js